<div class="u-dropdown-container">
  <p-dropdown
    [options]="options"
    [(ngModel)]="selectedValue"
    [class]="'u-dropdown ' + dropdownSize"
    [class.readonly]="readonly"
    (onClear)="onClearEvent($event)"
    [optionLabel]="optionLabel"
    (onChange)="onChangeEvent($event)"
    (onFilter)="onFilter.emit($event)"
    (onShow)="onShow.emit($event)"
    (onHide)="onHide.emit($event)"
    [filter]="filter"
    [filterBy]="filterBy"
    [emptyFilterMessage]="emptyFilterMessage"
    [showClear]="showClear"
    [placeholder]="placeholder"
    [appendTo]="appendTo"
    [panelStyleClass]="
      'u-dropdown-panel ' +
      (inTable ? 'panel-in-table ' : '') +
      (hideItemsContainer ? 'hide-items-container' : '') +
      (panelStyleClass ? panelStyleClass : '')
    "
    [styleClass]="styleClass"
    [style]="styles"
    [ngClass]="{
      'in-table': inTable,
      'outside-icon': dropdownSelectIcon && placeholder && !selectedValue,
      'hide-items-container': hideItemsContainer,
      'has-values': hasValues,
    }"
    [disabled]="disabled"
    [filterPlaceholder]="filterPlaceholder"
    [dataKey]="dataKey"
    #dropdown
  >
    <ng-template let-value pTemplate="selectedItem">
      <div class="new-selectedItem-container">
        <span *ngIf="dropdownType" class="dropdown-type">{{ dropdownType }}:</span>
        @if (iconTemplate) {
          <ng-container *ngTemplateOutlet="iconTemplate; context: { $implicit: value }"></ng-container>
        } @else if (showItemIconSelect) {
          <u-icon
            class="item-icon"
            [styles]="itemIconStyle"
            [model]="value?.icon"
            [inSvg]="iconInnerSvg ? value?.icon?.value?.lightUrl : null"
          ></u-icon>
        } @else {
          <div class="dropdown-icon">
            <u-icon
              [styles]="selectedItemIconStyle"
              [model]="dropdownSelectIcon"
              [inSvg]="iconInnerSvg ? dropdownSelectIcon?.value?.lightUrl : null"
            ></u-icon>
          </div>
        }
        <div
          class="new-selectedItem-label"
          [ngClass]="{ 'with-icon': dropdownSelectIcon }"
          tooltipPosition="top"
          [pTooltip]="value[optionLabel]"
          tooltipStyleClass="u-tooltip"
          [tooltipDisabled]="!showSelectedItemTooltip || value[optionLabel]?.length < maxCharacters"
        >
          {{ value[optionLabel] }}
        </div>
      </div>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="item-container" [ngClass]="{ disabled: item[disabledField] }">
        <div
          class="text-container"
          [ngClass]="{ 'add-element': inTable && item[optionLabel] === endListElement, 'has-sub-title': item[optionalSubLabel] }"
        >
          @if (iconTemplate) {
            <ng-container *ngTemplateOutlet="iconTemplate; context: { $implicit: item }"></ng-container>
          } @else {
            <u-icon
              class="item-icon"
              [styles]="itemIconStyle"
              [model]="item?.icon"
              [inSvg]="iconInnerSvg ? item?.icon?.value?.lightUrl : null"
            ></u-icon>
          }
          <div class="text">
            <span
              class="title"
              [class.has-sub-title]="item[optionalSubLabel]"
              [pTooltip]="item[optionLabel]"
              tooltipPosition="top"
              tooltipStyleClass="u-tooltip"
              [tooltipDisabled]="!showSelectedItemTooltip || item[optionLabel]?.length < maxCharacters"
              >{{ item[optionLabel] }}</span
            >
            <span class="sub-title" *ngIf="item[optionalSubLabel]">{{ item[optionalSubLabel] }}</span>
          </div>
          @if (item.badge) {
            <div class="badge-wrapper">
              <u-badge [text]="item.badge.text" [typeElement]="item.badge.type"></u-badge>
            </div>
          }
        </div>
        <u-icon
          *ngIf="item[disabledField] && item[disabledTooltipField]"
          [model]="{ type: 'font', value: 'icon-exclamation-mark-circle' }"
          class="item-disabled-icon"
          [styles]="{ color: 'var(--yellow-600)', fontSize: '14px' }"
          [pTooltip]="item[disabledTooltipField]"
          [disabled]="true"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
        ></u-icon>
        <i *ngIf="selectedValue?.[dataKey] && item?.[dataKey] === selectedValue?.[dataKey]" class="pi pi-check"></i>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div *ngIf="showClearAll && selectedValue && !dropdown?._filterValue()" class="clear-all-section" (click)="onClearAll()">
        <u-button [label]="showClearAllLabel" type="secondary" class="no-state clear-all" [styles]="_clearAllStyles"> </u-button>
      </div>
      @if (footerTemplate) {
        <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
      }
    </ng-template>
    <ng-template pTemplate="header">
      <i
        *ngIf="filter && dropdown?._filterValue && showClear"
        class="pi pi-times clear-icon dropdown-filter-clear-icon"
        (click)="clearFilter($event)"
      ></i>
    </ng-template>
  </p-dropdown>

  <div *ngIf="dropdownSelectIcon && placeholder && !selectedValue" class="dropdown-icon outside-dropdown">
    <u-icon [styles]="selectedItemIconStyle" [model]="dropdownSelectIcon"></u-icon>
  </div>
</div>
